const socketSize = 24;

export const SEQUENCE_NODE_WIDTH = "460px";
export const SOCKET_SIZE = `${socketSize}px`;
export const NESTED_NODE_HORIZONTAL_MARGIN = "16px";
export const COLLAPSED_NESTED_NODE_HEIGHT = "70px";
export const NODE_LABEL_DEFAULT_COLOR = "#e0e6ed";
export const NODE_INPUT_MARGIN_LEFT = "0px";
export const NODE_OUTPUT_MARGIN_RIGHT = "0px";